module.exports = __webpack_public_path__ + "img/keen_model_1.af8c5f98.png";